'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var applyButton = document.getElementById('applyCustomerIdForOrders');
    var customerIdForOrdersSelect = document.getElementById('customerIdForOrders');

    if (!applyButton || !customerIdForOrdersSelect || applyButton.registeredClick) return;

    applyButton.addEventListener('click', applyCustomerId);
    applyButton.registeredClick = true;

    function applyCustomerId() {
        var ordersB2C = (0, _jquery2.default)("#ordersB2C").DataTable().query(function (x) {
            x.customerId = customerIdForOrdersSelect.value;
        });
        ordersB2C.ajax.reload(null, true);
    }
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/filterOrdersByCustomerId.js
// module id = 411
// module chunks = 0